__turbopack_context__.v({
  "label": "TaxLine-module-scss-module__afw98q__label",
  "value": "TaxLine-module-scss-module__afw98q__value",
});
